import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleRectangleEdges extends AbstractPreset {
	getName(): string {
		return 'rectangleRectangleEdges';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "edges",
				"edgeType": "corners",
				"offset": 30,
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "rectangle",
					"primitives": {
						"width": 25,
						"length": 15
					},
					"modifiers": [],
					"position": {
						"left": 250,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}
}
